import {
  Col,
  Row,
  Space,
  Table,
  Tag,
  Card,
  Button,
  message,
  Spin,
  Input,
  Select,
  Tooltip,
  notification,
} from "antd";
import { useEffect, useMemo, useState } from "react";
import {
  ReloadOutlined,
  FilterOutlined,
  DownSquareOutlined,
  UpSquareOutlined,
  CheckCircleOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import MotionHoc from "../../../utils/MotionHoc";
import {
  HEADERS_EXPORT_BEN,
  POST_ACCEPT_DOC,
  POST_CHECK_DOC,
  POST_DOC_SUCCESS,
} from "../../API/apiUrls";

import axios from "axios";
import dayjs from "dayjs";
import { ThaiRangePicker } from "../../../hook/ThaiDatePicker";
import MemoDocReturn from "./modal/MemoDocReturn";

const Main = () => {
  const userId = 4; // เปลี่ยนตาม user จริง
  const userCompany = localStorage.getItem("COMPANY_ID");
  const [arrayTable, setArrayTable] = useState([]);
  const [dataArr, setDataArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchInputTable, setSearchInputTable] = useState(null);
  const [searchSelect, setSearchSelect] = useState(0);
  const [titelColumn, setTitelColumn] = useState(1);
  const [advanceSearch, setAdvanceSearch] = useState(true);
  const [datePickerTable, setDatePickerTable] = useState(null);
  const [arrow, setArrow] = useState("Show");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]); // ✅ เก็บ row ที่เลือก
  const [isModalMemoReturn, setIsModalMemoReturn] = useState(false);
  const [dataRecord, setDataRecord] = useState();

  const toggle = () => setAdvanceSearch((v) => !v);
  const { Option } = Select;

  // ✅ ข้อมูลเอกสารที่ต้องเตรียม
  const documentChecklist = [
    { key: "contract", label: "สัญญา (ตัวจริง)" },
    // { key: "collateral", label: "เอกสารหลักทรัพย์ (หน้าเล่ม, เอกสารจำนอง)" },
    // { key: "idCard", label: "สำเนาบัตรประชาชน" },
  ];

  const loadMainData = async (searchData) => {
    try {
      await axios
        .post(POST_CHECK_DOC, searchData, {
          headers: HEADERS_EXPORT_BEN,
        })
        .then(async (res) => {
          let i = 1;
          if (res.status === 200) {
            if (res.data.success === "ไม่พบข้อมูล") {
              message.warning("ไม่พบข้อมูล");
              return;
            }
            const newData = res?.data.map((item) => ({
              ...item,
              key: i++,
            }));
            filterData(newData);
          } else {
            message.error("ไม่มีข้อมูล");
            setArrayTable([]);
            setDataArr([]);
          }
          console.log("res Role", res.data);
        })
        .catch((err) => {
          console.log("ไม่มีข้อมูล", err);
          setArrayTable([]);
          setDataArr([]);
        });
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`ไม่พบข้อมูล: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  const renderOpteionSearch = () => {
    return (
      <>
        <Option value={0}>
          <span style={{ marginRight: 8 }}>📥</span>
          รอรับงาน
        </Option>
        <Option value={1}>
          <span style={{ marginRight: 8 }}>📝</span>รอดำเนินการ
        </Option>
        <Option value={2}>
          <span style={{ marginRight: 8 }}>✅</span>เตรียมสำเร็จ
        </Option>
        <Option value={3}>
          <span style={{ marginRight: 8 }}>↩️</span>ตีกลับ
        </Option>
      </>
    );
  };

  useEffect(() => {
    const DataLoad = {
      userId: userId,
      currentStatus: 1,
    };

    loadMainData(DataLoad);
  }, []);

  const handleLoad = (data) => {
    console.log(data);

    const DataLoad = {
      userId: userId,
      currentStatus: 1,
    };

    loadMainData(DataLoad);
    setTitelColumn(searchSelect);
    setSelectedRowKeys([]); // ✅ เคลียร์การเลือกหลังโหลดใหม่
  };

  const filterData = (data) => {
    if (Array.isArray(data)) {
      const newDataShow = data.filter(
        (item) => item.currentStatusAd === searchSelect,
      );

      setArrayTable(newDataShow);
      setDataArr(data);
    }
  };

  const handleFilterData = () => {
    setLoading(true);
    const rows = Array.isArray(dataArr) ? dataArr : [];
    const norm = (v) =>
      String(v ?? "")
        .trim()
        .toLowerCase();

    const sameDay = (a, b) =>
      !!a &&
      !!b &&
      dayjs(a).format("YYYY-MM-DD") === dayjs(b).format("YYYY-MM-DD");

    const inRange = (dt, [from, to]) => {
      if (!dt || !from || !to) return false;
      const ts = dayjs(dt).valueOf();
      const s = dayjs(from).startOf("day").valueOf();
      const e = dayjs(to).endOf("day").valueOf();
      return ts >= s && ts <= e;
    };

    const q = norm(searchInputTable);
    const dateSel = datePickerTable;

    const result = rows.filter((item) => {
      const passQuery =
        !q ||
        [item.CUSCOD, item.CONTNO, item.NAME1, item.NAME2]
          .map(norm)
          .some((val) => val.includes(q));

      let passDate = true;
      if (dateSel) {
        const dateToCheck = item.datetime || item.dateOnlineInvestigate;
        passDate =
          Array.isArray(dateSel) && dateSel.length === 2
            ? inRange(dateToCheck, dateSel)
            : sameDay(dateToCheck, dateSel);
      }

      return passQuery && passDate;
    });

    setArrayTable(result);

    setTimeout(() => {
      setLoading(false);
    }, 250);

    if (result.length === 0) {
      message.error("ไม่พบข้อมูล");
    } else {
      message.success(`พบข้อมูล ${result.length} รายการ`);
    }
  };

  // const accecptWork = async (dataLawsuit) => {
  //   console.log("Sending data...");
  //   console.log("dataLawsuit:", dataLawsuit);
  //   setLoading(true);
  //   try {
  //     const response = await axios.post(POST_ACCEPT_WORK, dataLawsuit, {
  //       headers: HEADERS_EXPORT_BEN,
  //     });

  //     if (response.status === 200) {
  //       console.log("Data sent successfully:", response.data);
  //       message.success("บันทึกข้อมูลสำเร็จ");
  //       handleLoad?.();
  //     } else {
  //       throw new Error("ไม่สามารถบันทึกข้อมูลได้");
  //     }
  //   } catch (error) {
  //     console.error("Error sending data:", error);
  //     const errorMsg = error.response?.data?.message || error.message;
  //     message.error(`เกิดข้อผิดพลาด: ${errorMsg}`);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handelChangeData = (value) => {
    setSearchSelect(value);
    const dataSelect = dataArr.filter((item) => item.currentStatusAd === value);
    setArrayTable(dataSelect);
    setSelectedRowKeys([]); // ✅ เคลียร์การเลือก
  };

  const handleBulkSave = async (status) => {
    if (selectedRowKeys.length === 0) {
      message.warning("กรุณาเลือกรายการที่ต้องการดำเนินการ");
      return;
    }

    setLoading(true);
    let successCount = 0;
    let failCount = 0;

    try {
      // ✅ หา records ที่ถูกเลือก
      const selectedRecords = arrayTable.filter((item) =>
        selectedRowKeys.includes(item.key),
      );

      // กรองเอาเฉพาะ record ที่ loanActive === 0
      const inactiveContnos = selectedRecords.filter(
        (item) => item.loanActive === 0,
      );

      console.log("inactiveContnos", inactiveContnos);

      if (inactiveContnos.length > 0) {
        const contnoList = [...new Set(inactiveContnos.map((d) => d.CONTNO))];

        return notification.error({
          message: "ไม่สามารถบันทึกได้ !",
          description: (
            <div>
              <div>พบสัญญาที่ไม่ ปิดไปแล้ว กรุณาตรวจสอบ !</div>
              <ul style={{ margin: "8px 0 0", paddingLeft: 20, color: "red" }}>
                {contnoList.map((contno, i) => (
                  <li key={i}>{contno}</li>
                ))}
              </ul>
            </div>
          ),
          duration: 10,
        });
      }
      console.log(`📤 กำลังส่งข้อมูล ${selectedRecords.length} รายการ...`);
      // ✅ วนส่งข้อมูลทีละ record
      for (const record of selectedRecords) {
        try {
          const payload = {
            loanId: record.loanId,
            lawsuitId: record.lawsuitId,
            userId: userId,
          };

          const apiUse = status === 0 ? POST_ACCEPT_DOC : POST_DOC_SUCCESS;
          await postDocStatus(payload, apiUse);

          successCount++;
          console.log(`✅ สำเร็จ: ${record.CONTNO}`);
        } catch (err) {
          failCount++;
          console.error(`❌ ล้มเหลว: ${record.CONTNO}`, err);
        }
      }

      // ✅ แสดงผลลัพธ์
      if (successCount > 0) {
        message.success(
          `${status === 0 ? "รับงาน" : "เตรียม"}สำเร็จ ${successCount} รายการ${
            failCount > 0 ? `, ล้มเหลว ${failCount} รายการ` : ""
          }`,
        );
        handleLoad(); // โหลดข้อมูลใหม่
      } else {
        message.error("ไม่สามารถดำเนินการได้");
      }
    } catch (err) {
      console.error("❌ Error in bulk save:", err);
      message.error("เกิดข้อผิดพลาดในการดำเนินการ");
    } finally {
      setLoading(false);
    }
  };

  const postDocStatus = async (payload, apiUse) => {
    console.log("📤 POST_DOC_STATUS with data:", payload);

    try {
      const res = await axios.post(apiUse, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      const { status, data } = res;

      if (status === 200) {
        console.log("✅ API Response:", data);
        return data;
      }
    } catch (error) {
      const status = error?.response?.status;
      const serverMsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error.message;

      if (status === 404) {
        message.error("ไม่พบปลายทาง (404)");
      } else if (status === 400) {
        message.error(`ข้อมูลไม่ถูกต้อง: ${serverMsg}`);
      } else if (status === 500) {
        message.error("เกิดข้อผิดพลาดจากเซิร์ฟเวอร์ (500)");
      } else {
        message.error(
          `ไม่สามารถส่งข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`,
        );
      }

      console.error("❌ postDocStatus error:", error);
      throw error;
    }
  };

  // ✅ Row Selection Config
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys) => {
      setSelectedRowKeys(selectedKeys);
      console.log("Selected Keys:", selectedKeys);
    },
    // getCheckboxProps: (record) => ({}),
  };

  // ✅ Expandable Row สำหรับรายละเอียดเอกสาร
  const expandedRowRender = (record) => {
    return (
      <div style={{ padding: "16px", backgroundColor: "#f9f9f9" }}>
        <h4 style={{ marginBottom: 12, color: "#1890ff" }}>
          📋 รายการเอกสารที่ต้องเตรียม
        </h4>
        <Space direction="vertical" size={8}>
          {documentChecklist.map((doc) => (
            <div
              key={doc.key}
              style={{ display: "flex", alignItems: "center" }}
            >
              <span>
                {"-  "}
                {doc.label}
              </span>
            </div>
          ))}
        </Space>
      </div>
    );
  };

  const columns = [
    {
      title: "ลำดับ",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: 80,
      render: (text, object, key) => key + 1,
    },
    {
      title: "เลขสัญญา",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
      render: (text, record) => <>{record.CONTNO}</>,
    },
    {
      title: "ชื่อ-นามสกุล",
      dataIndex: "dateSend",
      key: "dateSend",
      align: "center",
      render: (text, record) => (
        <>
          {`${record.SNAM}${record.NAME1} ${record.NAME2 ? record.NAME2 : ""}`}
        </>
      ),
    },
    {
      title: (() => {
        const titleMap = {
          0: "แจ้งส่งเมื่อ",
          1: "รับงานเมื่อ",
          2: "เตรียมสำเร็จเมื่อ",
          3: "เตรียมสำเร็จเมื่อ",
        };
        return titleMap[searchSelect] || "-";
      })(),
      align: "center",
      render: (text, record) => {
        const dateFieldMap = {
          0: record.ceoSend,
          1: record.acceptDocAd,
          2: record.completeCheckDocAd,
          3: record.completeCheckDocAd,
        };

        const dateValue = dateFieldMap[searchSelect];

        if (!dateValue) {
          return <Tag color="default">-</Tag>;
        }

        return (
          <Tag
            color={
              record.currentStatusAd === 0
                ? "red"
                : record.currentStatusAd === 1
                  ? "blue"
                  : record.currentStatusAd === 2
                    ? "green"
                    : record.currentStatusAd === 3
                      ? "orange"
                      : "default"
            }
          >
            {dayjs(dateValue).add(543, "year").format("D MMM YY")}
          </Tag>
        );
      },
    },
    {
      title: "สถานะ",
      align: "center",
      render: (record) => (
        <Tag
          color={
            record.loanActive === 1
              ? record.currentStatusAd === 0
                ? "red"
                : record.currentStatusAd === 1
                  ? "blue"
                  : record.currentStatusAd === 2
                    ? "green"
                    : record.currentStatusAd === 3
                      ? "orange"
                      : "default"
              : "default"
          }
        >
          {record.loanActive === 1
            ? record.currentStatusAd === 0
              ? "รอรับงาน"
              : record.currentStatusAd === 1
                ? "รอดำเนินการ"
                : record.currentStatusAd === 2
                  ? "เตรียมสำเร็จ"
                  : record.currentStatusAd === 3
                    ? "ตีกลับ"
                    : "-"
            : "ปิดสัญญาแล้ว"}
        </Tag>
      ),
    },
    searchSelect === 3 && {
      title: "การจัดการ",
      align: "center",
      render: (record) => {
        return (
          <Button
            type="text"
            color="orange"
            variant="outlined"
            onClick={() => {
              setDataRecord(record);
              setIsModalMemoReturn(true);
            }}
          >
            ตรวจสอบ
          </Button>
        );
      },
    },
  ].filter(Boolean);

  return (
    <>
      <Card>
        <Row>
          <Col span={24} style={{ textAlign: "start" }}>
            <Tooltip
              title={advanceSearch ? "ซ่อนตัวกรอง" : "แสดงตัวกรอง"}
              arrow={mergedArrow}
            >
              {advanceSearch ? (
                <DownSquareOutlined
                  style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                  onClick={toggle}
                />
              ) : (
                <UpSquareOutlined
                  style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                  onClick={toggle}
                />
              )}
            </Tooltip>
            <Space direction="horizontal" size={8}>
              <Select
                size="large"
                style={{ minWidth: "auto", marginRight: 8 }}
                placeholder="เลือกการค้นหา"
                popupMatchSelectWidth={false}
                value={searchSelect}
                onChange={(value) => handelChangeData(value)}
                showSearch
                optionFilterProp="label"
              >
                {renderOpteionSearch()}
              </Select>
              {advanceSearch ? (
                <Row>
                  <Col span={24} style={{ textAlign: "start" }}>
                    <Space size={10} wrap>
                      <ThaiRangePicker
                        value={datePickerTable}
                        onChange={setDatePickerTable}
                        size="large"
                      />
                      <Input
                        placeholder="ค้นหาสัญญาในตาราง"
                        value={searchInputTable}
                        onChange={(e) => setSearchInputTable(e.target.value)}
                        style={{
                          width: "auto",
                          borderRadius: "8px",
                        }}
                        size="small"
                        suffix={<span style={{ marginRight: 5 }}>🔍</span>}
                      />

                      <Button
                        icon={<FilterOutlined />}
                        size="large"
                        style={{
                          borderRadius: 8,
                          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                          fontWeight: "bold",
                          backgroundColor: "#fff7d6",
                          color: "#333",
                          border: "1px solid #ffe58f",
                        }}
                        onClick={() => handleFilterData()}
                        disabled={dataArr.length === 0}
                      >
                        กรองข้อมูล
                      </Button>
                      <Button
                        icon={<ReloadOutlined />}
                        onClick={() => {
                          setDatePickerTable(null);
                          setSearchInputTable(null);
                          setArrayTable(dataArr);
                        }}
                        color="red"
                        variant="outlined"
                        disabled={dataArr.length === 0}
                      >
                        ล้าง
                      </Button>
                    </Space>
                  </Col>
                </Row>
              ) : null}
            </Space>
          </Col>
        </Row>
      </Card>

      <Card>
        <Row style={{ marginBottom: 16 }}>
          <Col span={24}>
            {searchSelect === 0 && (
              <Button
                type="primary"
                ghost
                danger
                icon={<InboxOutlined />}
                onClick={() => handleBulkSave(0)}
                disabled={selectedRowKeys.length === 0}
              >
                📥 รับงาน ({selectedRowKeys.length})
              </Button>
            )}

            {searchSelect === 1 && (
              <Button
                type="primary"
                ghost
                icon={<CheckCircleOutlined />}
                onClick={() => handleBulkSave(1)}
                disabled={selectedRowKeys.length === 0}
              >
                ✅ เตรียมสำเร็จ ({selectedRowKeys.length})
              </Button>
            )}
          </Col>
        </Row>

        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Row>
            <Col span={24}>
              <Table
                size="small"
                columns={columns}
                dataSource={arrayTable}
                scroll={{ x: "max-content" }}
                {...([0, 1].includes(searchSelect) && { rowSelection })}
                expandable={{
                  expandedRowRender,
                  rowExpandable: (record) => true,
                }}
                footer={() => (
                  <div style={{ alignItems: "center" }}>
                    <p style={{ margin: 0 }}>
                      จำนวนสัญญาทั้งหมด {arrayTable?.length}
                      {searchSelect === 2 &&
                        ` | เลือก ${selectedRowKeys.length} รายการ`}
                    </p>
                  </div>
                )}
              />
            </Col>
          </Row>
        </Spin>
      </Card>
      {isModalMemoReturn && (
        <MemoDocReturn
          open={isModalMemoReturn}
          close={setIsModalMemoReturn}
          record={dataRecord}
          handleLoad={handleLoad}
          status={searchSelect}
        />
      )}
    </>
  );
};

const MainDocumentContno = MotionHoc(Main);
export default MainDocumentContno;
